/** Effective scores for LIVE/FINISHED fixtures (0–0 when live but no goals yet). */
export function effectiveMatchScores(m) {
  if (!m) return null;
  const h = m.home_score;
  const a = m.away_score;
  if (h != null && a != null) return { home: h, away: a };
  if (m.status === "LIVE") return { home: 0, away: 0 };
  return null;
}

/** Winner team code for a finished fixture (incl. AET and penalties). */
export function decidedFixtureWinnerCode(m) {
  if (!m) return null;
  const home = m.home_code;
  const away = m.away_code;
  const s = effectiveMatchScores(m);
  if (!s || s.home == null || s.away == null) return null;
  let wh = s.home;
  let wa = s.away;
  const aetH = m.home_score_aet;
  const aetA = m.away_score_aet;
  if (s.home === s.away && aetH != null && aetA != null) {
    wh = aetH;
    wa = aetA;
  }
  if (wh !== wa) {
    if (!home || !away) return null;
    return wh > wa ? home : away;
  }
  const explicit = m.decided_winner_code;
  if (explicit && home && away && (explicit === home || explicit === away)) return explicit;
  return null;
}

/** Result line for display: 1–1 (3–2 e.f.) when AET differs from regulation. */
export function formatMatchScore(m, lang = "sv") {
  const s = effectiveMatchScores(m);
  if (!s) return null;
  const aetH = m.home_score_aet;
  const aetA = m.away_score_aet;
  const etLabel = lang === "en" ? "AET" : "e.f.";
  if (aetH != null && aetA != null && (aetH !== s.home || aetA !== s.away)) {
    return `${s.home}–${s.away} (${aetH}–${aetA} ${etLabel})`;
  }
  return `${s.home}–${s.away}`;
}

/** Team code that advanced on penalties (draw after 90/AET + decided_winner_code). */
export function penaltyDecidedWinnerCode(m) {
  if (!m || m.status !== "FINISHED") return null;
  const explicit = m.decided_winner_code;
  if (!explicit) return null;
  const s = effectiveMatchScores(m);
  if (!s || s.home == null || s.away == null) return null;
  let wh = s.home;
  let wa = s.away;
  const aetH = m.home_score_aet;
  const aetA = m.away_score_aet;
  if (s.home === s.away && aetH != null && aetA != null) {
    wh = aetH;
    wa = aetA;
  }
  if (wh !== wa) return null;
  const home = m.home_code;
  const away = m.away_code;
  const code = String(explicit).trim().toUpperCase();
  if (home && String(home).toUpperCase() === code) return home;
  if (away && String(away).toUpperCase() === code) return away;
  return null;
}
